
export const MonthShortName: {[key:string]: string} = {
  "Jan": "01",
  "Feb": "02",
  "Mar": "03",
  "Apr": "04",
  "May": "05",
  "Jun": "06",
  "Jul": "07",
  "Aug": "08",
  "Sep": "09",
  "Oct": "10",
  "Nov": "11",
  "Dec": "12"
}

export const checkStatusDateFormat = (date: string): boolean => {
  const dateTime = date.split(" ");
  if(dateTime.length !== 2) return false;
  const listDate = dateTime[0].split("/");
  if(listDate.length !== 3) return false;
  const listTime = dateTime[1].split(":");
  if(listTime.length !== 2) return false;
  return true;
}

export const getDate = (dateTime: Date, separator: string = "-"): string => {
  const date = dateTime.toString().split(" ");
  if(date.length === 2) return ""; // Invalid Date
  return date[3] + separator + MonthShortName[date[1]] + separator + date[2];
}

export const getDateTime = (dateTime: Date, separatorDate: string = "/", separatorTime: string = ":"): string => {
  const date = dateTime.toString().split(" ");
  if(date.length === 2) return ""; // Invalid Date
  const time = date[4].split(":");
  return date[2] + separatorDate + MonthShortName[date[1]] + separatorDate + date[3] + " " + time[0] + separatorTime + time[1];
}

export type ComplexFieldMaxDateFn = (now: Date) => Date;

export const COMPLEX_FIELD_MAX_DATE_BY_KEY: Record<string, ComplexFieldMaxDateFn> = {
  educationalInstitutionsUntil: (now) => {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    //d.setDate(d.getDate() - 7);
    return d;
  },
  spouseEducationalInstitutionsUntil: (now) => {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    //d.setDate(d.getDate() - 7);
    return d;
  },
  workExperienceUntil: (now) => {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    //d.setDate(d.getDate() - 7);
    return d;
  },
  spouseWorkExperienceUntil: (now) => {
    const d = new Date(now);
    d.setHours(0, 0, 0, 0);
    //d.setDate(d.getDate() - 7);
    return d;
  },
};

export const getMaxDateForComplexFieldKey = (
  key: string | null | undefined,
  now: Date = new Date()
): Date | null => {
  if (!key) return null;
  const fn = COMPLEX_FIELD_MAX_DATE_BY_KEY[key];
  return fn ? fn(now) : null;
};

export const hasComplexFieldMaxDateKey = (key: string | null | undefined): boolean =>
  !!key && Object.prototype.hasOwnProperty.call(COMPLEX_FIELD_MAX_DATE_BY_KEY, key);

/** Clamps YYYY-MM-DD to the key's max date (from `now`) when the value is newer than allowed */
export const clampComplexFieldDateString = (
  value: string,
  key: string | null | undefined,
  now: Date = new Date()
): string => {
  const max = getMaxDateForComplexFieldKey(key, now);
  if (!max) return value;
  if (!value) return value;
  const parts = value.split("-");
  if (parts.length !== 3) return value;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(day)) return value;
  const selected = new Date(y, m, day);
  if (selected.getTime() > max.getTime()) {
    const mm = String(max.getMonth() + 1).padStart(2, "0");
    const dd = String(max.getDate()).padStart(2, "0");
    return `${max.getFullYear()}-${mm}-${dd}`;
  }
  return value;
};